import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AdminNavbar = () => {
  return (
    <div className="admin-navbar card mb-4">
      <div className="card-body p-0">
        <ul className="nav nav-pills nav-fill">
          <li className="nav-item">
            <Link className="nav-link active" to="/admin">
              <i className="fas fa-tachometer-alt me-2"></i>
              Dashboard
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/admin/users">
              <i className="fas fa-users me-2"></i>
              Usuarios
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

const AdminLayout = ({ children }) => {
  const { currentUser } = useAuth();
  
  // Versión simplificada sin verificación estricta para desarrollo
  return (
    <div className="container mt-4">
      <div className="card mb-4">
        <div className="card-body bg-dark text-white">
          <h2 className="text-center mb-0">Panel de Administración - WintonCoin</h2>
        </div>
      </div>
      
      <AdminNavbar />
      
      <div className="admin-content mt-4">
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
